<script>
export default {
    name: 'LogoutMixin',

    created() {
        window.localStorage.removeItem('vuex')
    },
}
</script>
